import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { useField } from 'formik';

import { PoolTextfield, PoolTextfieldProps } from './pool-textfield';

export const PoolFormikTextfield = (
    props: PoolTextfieldProps & { name: string; helperTextValues?: { [key: string]: string | number } }
): ReactElement => {
    const { name, helperTextValues, ...textFieldProps } = props;
    const [field, meta] = useField({ name });

    return (
        <PoolTextfield
            error={meta.touched && !!meta.error}
            helperText={
                meta.touched && meta.error ? <FormattedMessage id={meta.error} values={helperTextValues} /> : ' '
            }
            {...field}
            {...textFieldProps}
        />
    );
};
